// src/api/apiService.js
import { toast } from "react-toastify";
import axiosClient from "./axiosClient";
import { GRAPH_API_KEY } from "../utils/constant";

export const apiRequest = async ({ url, method = "GET", data = null, params = {}, auth }) => {

  try {
    // ✅ Get token from localStorage
    const token = localStorage.getItem("accessToken");

    // ✅ Build headers with Authorization if token exists
    const headers = auth
      ? token
        ? { Authorization: `Bearer ${token}` }
        : {}
      : { Authorization: `Bearer ${GRAPH_API_KEY}` };
    // ;
    const response = await axiosClient({
      url,
      method,
      data,
      params,
      headers,
    });

    return response;
  } catch (error) {
    console.error("API Request Error:", error);

    const message = error?.response?.data?.message || "An error occurred. Please try again.";

    // ✅ Check for JWT expiration or invalid token
    if (
      message.toLowerCase().includes("jwt expired") ||
      message.toLowerCase().includes("token expired") ||
      message.toLowerCase().includes("unauthorized") || 
      message.toLowerCase().includes("jwt")
    ) {
      // 🔒 Disconnect wallet

      // 🧹 Remove invalid token
      localStorage.removeItem("accessToken");

      // ⚠️ Notify user
      toast.error("Session expired. Please connect your wallet again.", {
        toastId: "jwt-expired",
      });
    } else {
      toast.error(message, { toastId: "api-error" });
    }

    throw error;
  }
};
